export default "__VITE_ASSET__LzknG8ev__"